import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo-transparent.png";

const desktopLinkBaseClass =
  "rounded-full border border-transparent px-4 py-2 text-sm font-semibold text-brandDeep transition duration-300 ease-smooth hover:border-brand/20 hover:bg-brandSoft/65 hover:text-brandDeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand";
const activeDesktopLinkClass =
  "border-brand/25 bg-brandSoft/80 text-brandDeep shadow-soft hover:bg-brandSoft/80 hover:text-brandDeep";
const mobileLinkBaseClass =
  "block rounded-2xl border border-transparent px-4 py-3 text-center text-base font-semibold text-brandDeep transition duration-300 ease-smooth hover:border-brand/20 hover:bg-brandSoft/65 hover:text-brandDeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand";
const activeMobileLinkClass = "border-brand/25 bg-brandSoft/80 text-brandDeep shadow-soft";

function NavbarComponent() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const isActive = (path) =>
    path === "/portfolio"
      ? location.pathname === path || location.pathname.startsWith(`${path}/`)
      : location.pathname === path;

  return (
    <header className="sticky top-0 z-50 border-b border-white/60 bg-white/80 backdrop-blur-xl">
      <nav
        className="relative mx-auto flex w-full max-w-site items-center justify-between px-4 py-3 sm:px-6 lg:px-8"
        aria-label="Navigation principale"
      >
        <Link
          to="/"
          className="flex items-center gap-3 rounded-full pr-3 transition duration-300 ease-smooth hover:bg-white/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
          title="Accueil"
        >
          <span className="flex h-14 w-14 items-center justify-center rounded-full border border-brand/20 bg-white shadow-soft sm:h-16 sm:w-16">
            <img
              src={logo}
              alt="Logo Sofiane Amroune, développeur web"
              className="h-11 w-11 object-contain sm:h-12 sm:w-12"
            />
          </span>
          <span className="hidden min-w-0 flex-col sm:flex">
            <span className="truncate text-base font-semibold tracking-tight text-ink lg:text-lg">
              Sofiane Amroune
            </span>
            <span className="text-sm text-muted">
              Développeur web sénior
            </span>
          </span>
        </Link>

        <div className="hidden items-center gap-2 lg:flex">
          <Link
            to="/"
            className={`${desktopLinkBaseClass} ${
              isActive("/") ? activeDesktopLinkClass : ""
            }`}
            aria-current={isActive("/") ? "page" : undefined}
          >
            CV
          </Link>
          <Link
            to="/portfolio"
            className={`${desktopLinkBaseClass} ${
              isActive("/portfolio") ? activeDesktopLinkClass : ""
            }`}
            aria-current={isActive("/portfolio") ? "page" : undefined}
          >
            Portfolio
          </Link>
          <Link
            to="/about"
            className={`${desktopLinkBaseClass} ${
              isActive("/about") ? activeDesktopLinkClass : ""
            }`}
            aria-current={isActive("/about") ? "page" : undefined}
          >
            À propos
          </Link>
          <Link
            to="/contact"
            className={`${desktopLinkBaseClass} ${
              isActive("/contact") ? activeDesktopLinkClass : ""
            }`}
            aria-current={isActive("/contact") ? "page" : undefined}
          >
            Contact
          </Link>
        </div>

        <div className="lg:hidden">
          <button
            type="button"
            onClick={() => setIsOpen((previousState) => !previousState)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white text-brandDeep shadow-sm transition duration-300 ease-smooth hover:border-brand/35 hover:bg-surface focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
            aria-controls="mobile-navigation"
            aria-expanded={isOpen}
            aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
          >
            <span className="sr-only">
              {isOpen ? "Fermer le menu" : "Ouvrir le menu"}
            </span>
            {isOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
          </button>
        </div>

        <div
          id="mobile-navigation"
          className={`${
            isOpen ? "block" : "hidden"
          } absolute left-4 right-4 top-[calc(100%+0.75rem)] rounded-panel border border-line bg-white/95 p-3 shadow-panel backdrop-blur lg:hidden`}
        >
          <Link
            to="/"
            className={`${mobileLinkBaseClass} ${
              isActive("/") ? activeMobileLinkClass : ""
            }`}
            aria-current={isActive("/") ? "page" : undefined}
          >
            CV
          </Link>
          <Link
            to="/portfolio"
            className={`${mobileLinkBaseClass} ${
              isActive("/portfolio") ? activeMobileLinkClass : ""
            }`}
            aria-current={isActive("/portfolio") ? "page" : undefined}
          >
            Portfolio
          </Link>
          <Link
            to="/about"
            className={`${mobileLinkBaseClass} ${
              isActive("/about") ? activeMobileLinkClass : ""
            }`}
            aria-current={isActive("/about") ? "page" : undefined}
          >
            À propos
          </Link>
          <Link
            to="/contact"
            className={`${mobileLinkBaseClass} ${
              isActive("/contact") ? activeMobileLinkClass : ""
            }`}
            aria-current={isActive("/contact") ? "page" : undefined}
          >
            Contact
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default NavbarComponent;
